import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {setCartRequest, setCart, editItem, setOrderDone, verifyCartRequest, addPopup, doPayment} from "../../redux/actions";
import './index.scss';

import * as Router from '../../constants/routes';
import * as Popups from '../../constants/popup-types';

//components
import OrderDetails from "./orderDetails";
import UserDetails from './userDetails';
import OrderConclusion from './orderConclusion';

//assets
import cartImg from 'assets/icons/cart.svg';
import mark from 'assets/icons/mark.svg';
import Loader from "../../components/common/loader";
import { createAnalyticsItemsList, getMediaPath } from '../../app/functions';
import * as popups from "../../constants/popup-types";
import AnalyticsManager from '../../app/analytics';

class PaymentPage extends Component{
    constructor(props){
        super(props);

        this.state = {
            first_try: true,
        };
        this.requesting = false;
    }

    componentDidMount() {
        if (!this.props.cart) {
            this.props.history.push(Router.home);
        }
    }

    componentDidUpdate(prevProps){

        if (prevProps.verificationStatus !== this.props.verificationStatus){
            if (this.props.verificationStatus !== false) {
                this.requesting = false;
                this.props.addPopup({
                    type: Popups.PURCHASE_APPROVAL,
                    action: this.handleDoPayment,
                    price: this.props.cart.total_sum,
                    phone: this.props.userData.phone,
                })
            }
        }

        if((prevProps.orderStatus !== this.props.orderStatus) && this.props.orderStatus){

            if (this.props.orderStatus.hasOwnProperty('err')){
                this.requesting = false;
            }

            else {
                //Google-Tag Adapt
                const items = this.props.cart.itemsArr;
                let payload = [];
                for (let key in items) {
                    const item = items[key];
                    payload.push(
                        {
                            sku: item.sku,
                            price: item.price,
                            quantity: item.quantity,
                            order_id: this.props.orderStatus.order_id
                        })
                }

                //initialize the order status to false
                // this.props.setOrderDone(false);
                this.props.history.push(Router.thanks + '/' + this.props.orderStatus.order_id);
            }
        }
    }

    getDefaultCard = () =>{

        const userData = this.props.userData;

        let res = null;

        for (let key in userData.cardsArr){
            const item = userData.cardsArr[key];
            if (item.default){
                res = item.id;
            }
        }

        return res;
    };

    handleDoPayment = () =>{
        const { benefitData, cart } = this.props;

        const benefitId = cart?.itemsArr?.[0]?.item_id;
        const totalSum = cart?.total_sum;
        const totalQuantity = cart?.itemsArr?.[Object.keys(cart?.itemsArr)?.[0]]?.quantity;

        const doPaymentParams ={
            benefitId: benefitId,
            totalSum: totalSum,
            token: this.getDefaultCard(),
            deliveryId: 1,
            comment: this.props.userComment,
        };

        this.props.doPayment(doPaymentParams, (response) => {
            const transactionId = `${benefitId}-${response?.order_id}`;
            const boughtItem = cart?.itemsArr?.[Object.keys(cart?.itemsArr)?.[0]];

            AnalyticsManager.logPurchase(createAnalyticsItemsList([{
                ...benefitData,
                title: `${boughtItem?.title} (${boughtItem?.sub_title})`,
                price: boughtItem?.price,
                quantity: totalQuantity,
            }]), totalSum, transactionId);

            AnalyticsManager.logProductBuyWithClickSuccess(benefitId, totalSum);
        });
    };

    handleDoVerification = () =>{
        //show loader while requesting
        this.requesting = true;

        this.setState({first_try: false});

        this.props.verifyCartRequest();
    };

    dataOnChange = (id,field, value) =>{
        const cart = this.props.cart.itemsArr;
        let payload = {...this.props.requestCart};

        payload[id][field] = value;

        this.props.setCartRequest(payload);

        this.props.editItem({
            itemKey: cart[id].item_key,
            customizationArr: JSON.stringify(payload[id]),
        });
    };

    getOrders = () =>{
        const cart = this.props.cart.itemsArr;
        const requestCart = this.props.requestCart;

        let res = [];

        for (let key in cart){
            res.push(
                <OrderDetails key={key}
                              dataOnChange={this.dataOnChange}
                              spinnersData={requestCart[key]}
                              data={cart[key]}
                              id={key}
                              firstTry={this.state.first_try}
                />
            )
        }

        return res;
    };

    handleOnDelete = () =>{
        //initialize redux cart
        this.props.setCart(false);
        this.props.history.goBack();
    };

    render(){
        const cart = this.props.cart;

        const requestCart = this.props.requestCart;

        const text = this.props.text;

        return(
            <section className='payment-page'>
                {this.requesting && <Loader className='payment-loader'/>}
                {cart &&
                <Fragment>
                    <div className='desktop-view'>
                        <div className='cart-wrap'>
                            <img src={getMediaPath(cartImg)} alt=''/>
                            <span>{text['payment_cart']}</span>
                            <span className='delete' onClick={this.handleOnDelete}>{text['payment_delete']}</span>
                        </div>

                        {this.getOrders()}

                        <UserDetails id={Object.keys(requestCart)[0]}/>

                        <div className='protocol'>
                            <img src={getMediaPath(mark)} alt=''/>
                            <div className='text-wrapper'>
                                <span className='bold'>{text['payment_protocol']}</span>
                                <span>{text['payment_protocol_light']}</span>
                            </div>
                        </div>
                    </div>

                    < OrderConclusion onDoPayment={this.handleDoVerification}/>
                </Fragment>
                }
            </section>
        )
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        cart: store.config.Cart,
        requestCart: store.config.cartRequest,
        orderStatus: store.config.OrderIsDone,
        userData: store.config.UserData,
        userComment: store.config.UserComment,
        verificationStatus: store.data.VerificationStatus,
        taxPercent: store.config.TaxPercent,
        benefitData: store.data.LastBenefitPage,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        setCartRequest:(payload) =>dispatch(setCartRequest(payload)),
        setCart:(payload) =>dispatch(setCart(payload)),
        editItem:(payload) =>dispatch(editItem(payload)),
        setOrderDone:(payload) =>dispatch(setOrderDone(payload)),
        verifyCartRequest:(payload) =>dispatch(verifyCartRequest(payload)),
        addPopup: (payload) => dispatch(addPopup(payload)),
        doPayment: (payload, onPurchase) => dispatch(doPayment(payload, onPurchase)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PaymentPage);
